export { default as CommonTableHead } from "./CommonTableHead"
